import React from 'react'
export default class Loading extends React.Component{
    render(){
        return (
            <div className="pleasewait">Loading please wait...</div>
        )
    }
}